/** @module csi/widget/_svg/SaveAndFinish */
define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory"
], function(Button, _Plugin, PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		"class": "csi-primary-btn",
		label: "CanvasSaveAndFinish",
		pluginName: "saveAndFinish",
		showLabel: true,

		/**
		 * @override
		 * Disable plugin if cannot edit the canvas - it's possible the state changes once in edit mode
		 */
		enablePlugin(shapes, shapeAttrs, textAttrs) {
			return this.getView().canEditCanvas() && this.inherited(arguments);
		},

		/**
		 * Save canvas and exit edit mode; use throttled on click to prevent double-click errors
		 */
		onClickThrottled: function() {
			this.getView().save(true);
		}
	});
});
